/**
 * RequestApprovalStatusService
 * Service for RequestApprovalStatus entity operations
 * Route: api/requestapprovalstatus
 * Controller: RequestApprovalStatusController.cs
 */
import { CrudService } from '../base/CrudService';
/**
 * RequestApprovalStatusService
 * Handles request approval status CRUD operations
 * Maps to /api/requestapprovalstatus endpoint
 */
export class RequestApprovalStatusService extends CrudService {
    constructor(http, config) {
        super(http, {
            servicePath: config?.servicePath ?? RequestApprovalStatusService.DEFAULT_SERVICE_PATH,
            basePath: RequestApprovalStatusService.BASE_PATH,
            endpoints: config?.endpoints,
        });
    }
}
RequestApprovalStatusService.DEFAULT_SERVICE_PATH = 'procurements';
RequestApprovalStatusService.BASE_PATH = 'api/requestapprovalstatus';
//# sourceMappingURL=RequestApprovalStatusService.js.map